import axios from "axios";
import { API_URL } from "../config/constants";

// const API_URL = "http://localhost:5000/api/auth/";

const END_POINT = `${API_URL}users/`

export const addChangePassword = (currentPassword, newPassword, confirmPassword) => {
   
    return axios
        .post(`${END_POINT}changing-password`, {currentPassword, newPassword, confirmPassword})
        .then((response) => {
            return response;
        }).catch(e => {
            console.log("error occured in addChangePassword", e)
            return e?.response;
        });
};